import axios from 'axios'
// 创建一个 axios 实例
const service = axios.create({
  // baseURL: 'http://ptstpdtest.lenovo.com.cn',
  timeout: 5000,// 请求超时时间
	headers: {
	   'Referer':'https://ptstpd.lenovo.com.cn/', // 根据实际情况设置 Referer 或其他自定义头
	 }
})
// function htmlDecodeByRegExp (str) {  
//   var s = ''
//   if (str.length == 0) return ''
//   s = str.replace(/&amp;/g, '&')
//   s = s.replace(/&lt;/g, '<')
//   s = s.replace(/&gt;/g, '>')
//   s = s.replace(/&nbsp;/g, ' ')
//   s = s.replace(/&#39;/g, "\'")
//   s = s.replace(/&quot;/g, '\"')
//   s = s.replace(/(\\\\\*)/g, '\*')
//   s = s.replace(/(\\\\\%)/g, '\%')
//   s = s.replace(/(\\\\\_)/g, '\_')
//   return s
// }
function htmlDecodeByRegExp (str) {  
  var s = ''
  if (str.length == 0) return ''
  s = str.replace(/&amp;/g, '&')
  s = s.replace(/&lt;/g, '<')
  s = s.replace(/&gt;/g, '>')
  s = s.replace(/&nbsp;/g, ' ')
  s = s.replace(/&#39;/g, "'")
  s = s.replace(/&quot;/g, '"')
  s = s.replace(/\\\*/g, '*')
  s = s.replace(/\\\%/g, '%')
  s = s.replace(/\\\_/g, '_')
  return s
}
function decodeJson (json) {
  if (Object.prototype.toString.call(json) === '[object Object]' || Object.prototype.toString.call(json) === '[object Array]') {
    for (var item in json) {
      json[item] = decodeJson(json[item])
    }
    return json
  } else if (Object.prototype.toString.call(json) === '[object String]') {
    return htmlDecodeByRegExp(json)
  } else {
    return json
  }
}
// 带cookies
service.defaults.withCredentials = true
// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // 发送失败
    Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(
  response => {
    return decodeJson(response)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/plugin/axios/index.js